// Nutrition Facts Lightbox
(function() {
  let initialized = false;
  
  function initNutritionLightbox() {
    if (initialized) return;
    initialized = true;
    
    const lightboxTrigger = document.querySelector('[data-nutrition-lightbox]');
    const lightbox = document.getElementById('nutritionLightbox');
    const closeButtons = document.querySelectorAll('[data-lightbox-close]');
    
    if (!lightboxTrigger || !lightbox) return;
    
    // Open lightbox
    lightboxTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      // Fade in animation
      setTimeout(() => {
        lightbox.style.opacity = '1';
      }, 10);
    });
    
    // Close lightbox
    closeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        closeLightbox();
      });
    });
    
    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.style.display === 'flex') {
        closeLightbox();
      }
    });
    
    function closeLightbox() {
      lightbox.style.opacity = '0';
      setTimeout(() => {
        lightbox.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNutritionLightbox);
  } else {
    initNutritionLightbox();
  }
})();
